import ShCard from '@/components/Helpers/ShCard';
import NotificationsListItemConfiguration from './NotificationsListItemConfiguration';

export default {
  name: 'NotificationsListItem',

  components: {
    ShCard,
    NotificationsListItemConfiguration,
  },

  props: {
    name: {
      type: String,
      default: 'Konfiguracja powiadomienia',
    },
    slug: {
      type: String,
      default: '',
    },
    position: {
      type: Number,
      default: 1,
    },
    description: {
      type: String,
      default: 'Opis danej konfiguracji',
    },
    configuration: {
      type: Object,
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'notifications/saveConfiguration',
      ]);
    },
  },

  methods: {
    async handleChangeConfiguration(configuration) {
      let notificationConfiguration = {};
      notificationConfiguration[`${this.slug}_is_active`] = configuration.isActive.toString();
      notificationConfiguration[`${this.slug}_notification_type`] = configuration.type;
      notificationConfiguration[`${this.slug}_notification_recipient`] = configuration.recipient;

      await this.$store.dispatch('notifications/saveConfiguration', notificationConfiguration);
      this.$notify.success({
        title: 'Konfiguracja powiadomień',
        message: `Zapisano konfigurację "${this.name}"`,
        customClass: 'callmeweb-notification',
      });
      await this.$store.dispatch('notifications/getList');
    },
  },
};
